// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1k2iA","title":"Header_title__rI6xQ","rightSection":"Header_rightSection__iOaNY"};